<template>
  <div class="main bgc-fff c-333 fs-18 ff-as">
    <div class="banner p-r">
      <div class="banner-img bgs-cover"></div>
      <div class="banner-text p-a c-c m-a ta-c c-fff">
        <h1 class="m-0 fs-50">Digital Construction</h1>
        <div class="c-ddd lh-15 fs-26"></div>
      </div>
    </div>

    <section class="area-1 pl-60 pr-60 ta-c">
      <div class="m-a c-59 lh-15">
        We don’t do construction, but we are transforming construction. FJD machine control system is based on GNSS
        positioning, RTK technology and multi-sensor integration, and is recognized for our open and compatible
        solutions. It is possible to deliver seamless workflow on various job sites.
      </div>
    </section>

    <section class="area-3 product-mod pl-60 pr-60">
      <h2 class="m-0 fs-40 c-26 ta-c">— Digital Construction —</h2>
      <ul class="d-f jc-c ta-c">
        <li>
          <a href="/product/fjd-easy-dig-g21-2d-excav">
            <h3 class="">FJD Easydig G21 <br />2D Excavator Guidance System</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="FJD Easydig G21 2D Excavator Guidance System"
                src="@/assets/images/industry/2d-wj.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </a>
        </li>
        <li>
          <a href="/product/excavatorguidance">
            <h3 class="">FJD G31 <br />3D Excavator Guidance System</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="3D Excavator Guidance System"
                src="@/assets/images/industry/ALo1 3D.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </a>
        </li>
        <li>
          <a href="/product/piledriver">
            <h3 class="">FJD G32 <br />Smart Pile Driver Guidance System</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="Smart Pile Driver Guidance System"
                src="@/assets/images/industry/FarmbookPrecision Agriculture Solution.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </a>
        </li>
        <li>
          <a href="/product/basestation">
            <h3 class="basestation-h3">FJD Satellite <br />Navigation Base Station</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="RTK Base Station"
                src="@/assets/images/industry/RTK-base-station.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </a>
        </li>
      </ul>
    </section>

    <!-- <section class="area-3 product-mod pl-60 pr-60">
      <h2 class="m-0 fs-40 c-26 ta-c fw-500">— Digital Construction —</h2>
      <ul class="d-f jc-c ta-c">
        <li>
          <nuxt-link to="/product/excavatorguidance">
            <h3 class="">
              3D Excavator <br />
              Guidance System
            </h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="3D Excavator Guidance System
                  "
                src="@/assets/images/industry/ALo1 3D.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/product/piledriver">
            <h3 class="">
              Smart Pile Driver <br />
              Guidance System
            </h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="Smart Pile Driver Guidance System"
                src="@/assets/images/industry/FarmbookPrecision Agriculture Solution.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/product/basestation">
            <h3 class="basestation-h3">RTK Base Station</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="RTK Base Station"
                src="@/assets/images/industry/RTK-base-station.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
      </ul>
    </section> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .product-mod .more b {
    transition: transform 0.3s;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23262626' stroke-linecap='round' stroke-linejoin='round' d='M4.5 10l4-4-4-4' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E");
  }

  /* pc端样式 */
  @media screen and (min-width: 768px) {
    .main {
      margin-top: 3.958vw;
    }

    /* banner */
    .banner-img {
      /* padding-top: 26.0416vw; */
      padding-top: 3.6rem;
      background-position: top center;
      background-image: url('@/assets/images/business/p1-d.jpg');
    }
    .banner-text {
      display: block;
      /* width: 52.0833vw;
    top: 50%;
    left: 15.1vw;
    text-align: left;
    transform: translate(0, -50%); */
    }
    .banner-text h1 {
      margin-bottom: 15px;
    }

    /* area-1 */
    /* .area-1, */
    .area-2 {
      padding-top: 1rem;
    }
    .area-1 {
      padding: 0.48rem 18.75vw 0.8rem 18.75vw;
    }
    .area-1 li i {
      width: 5.2083vw;
      height: 5.2083vw;
      display: block;
      margin: 0 auto 15px;
    }
    .area-1 ul {
      padding: 5.625vw 20px 0;
    }

    .product-mod ul {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
    .product-mod h2 {
      margin-bottom: 0.62rem;
    }
    .product-mod li {
      width: 32.15%;
      height: 5.6rem;
      padding: 0.62rem 0.56rem 0.48rem;
      background-color: #fafafa;
      box-sizing: border-box;
      margin-left: 0.16rem;
      margin-bottom: 0.16rem;
    }
    .product-mod li:last-child {
      margin-right: 0;
    }
    .product-mod li i {
      display: block;
      margin: 0.16rem 0;
      width: 4.8rem;
      height: 3.4rem;
    }
    .product-mod li h3 {
      font-size: 0.28rem;
      font-weight: 500;
      color: #262626;
      /* line-height: 0.42rem; */
      /* margin-bottom: 0.16rem; */
    }

    .product-mod li a {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 4.15rem;
    }

    .product-mod li h3 b {
      display: block;
    }
    .product-mod li span {
      font-size: 0.16rem;
      border: 1px solid #262626;
      margin: 0 auto;
      padding: 0.06rem 0.16rem 0.06rem 0.2rem;
    }
    .product-mod li span em {
      color: #262626;
    }
    .product-mod .more b {
      width: 12px;
      height: 12px;
      margin-left: 5px;
    }
    .product-mod li a:hover b {
      transform: translateX(6px);
    }
    .product-mod li a:hover img {
      transform: scale(1.05);
    }
    .product-mod li img {
      transition: transform 0.3s ease-out;
    }
    /* .basestation-h3{
    margin-bottom: .32rem;
  } */

    .area-3 {
      margin-bottom: 1.2rem;
    }

    .area-4 {
      width: 12rem;
      margin: 0 auto;
      padding-bottom: 1.2rem;
    }
    .area-4-content {
      flex-direction: row-reverse;
    }
    .left-img {
      width: 6.8rem;
      background-image: url('@/assets/images/industry/construction-bottom-img.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-clip: border-box;
    }
    .right-content {
      margin-right: 0.24rem;
    }
    .right-content > div {
      margin-bottom: 0.27rem;
    }

    .right-content img {
      margin-right: 0.24rem;
    }
    .right-content h3 {
      height: 0.36rem;
      font-size: 0.24rem;
      color: #262626;
      line-height: 0.36rem;
      margin-bottom: 0.08rem;
    }
    .right-content p {
      height: 0.52rem;
      font-size: 0.18rem;
      color: #595959;
      line-height: 0.26rem;
    }

    /* .area-4-mod-1 .area-4-mod-img{ background-image: url("@/assets/images/agriculture_solution/area_4_1.jpg");}
  .area-4-mod-2 .area-4-mod-img{ background-image: url("@/assets/images/agriculture_solution/area_4_2.jpg");}
  .area-4-mod-3 .area-4-mod-img{ background-image: url("@/assets/images/agriculture_solution/area_4_3.jpg");}
  .area-4-mod-4 .area-4-mod-img{ background-image: url("@/assets/images/agriculture_solution/area_4_4.jpg");}
  .area-4-mod-5 .area-4-mod-img{ background-image: url("@/assets/images/agriculture_solution/area_4_5.jpg");} */
  }

  /*pc端样式 1440px ~  1650px*/
  @media screen and (max-width: 1650px) and (min-width: 1440px) {
    .fs-50 {
      font-size: 40px;
    }
    .fs-40 {
      font-size: 30px;
    }
    .fs-26 {
      font-size: 24px;
    }
    /* .product-mod li h3 {
    font-size: 24px;
  } */
  }

  /*pc端样式 1200px ~  1440px*/
  @media screen and (max-width: 1440px) and (min-width: 1200px) {
    .fs-50 {
      font-size: 30px;
    }
    .fs-40 {
      font-size: 26px;
    }
    .fs-26 {
      font-size: 20px;
    }
    .banner-text {
      width: 70%;
      top: 50%;
    }
    .area-1 li i {
      width: 80px;
      height: 80px;
    }
    .area-1 li span {
      font-size: 16px;
    }
    /* .product-mod li h3 {
    font-size: 20px;
  } */
    .product-mod li span {
      font-size: 14px;
    }
  }

  /*pc端样式 768px ~  1200px*/
  @media screen and (max-width: 1200px) and (min-width: 768px) {
    .fs-50 {
      font-size: 28px;
    }
    .fs-40 {
      font-size: 24px;
    }
    .fs-26 {
      font-size: 18px;
    }
    .fs-18 {
      font-size: 16px;
    }
    .banner-text {
      width: 90%;
      top: 50%;
    }
    .area-1 li i {
      width: 70px;
      height: 70px;
    }
    .area-1 li span {
      font-size: 16px;
    }
    /* .product-mod li h3 {
    font-size: 18px;
  } */
    .product-mod li span {
      font-size: 14px;
    }
  }
</style>
